module.exports = __webpack_public_path__ + "img/8_1703_shady_32_hotel.8a31fd67.jpg";